import api from "./api";
import bcrypt from "bcryptjs";

export async function requestPrimeiraConsultaDadosClinicos(data) {
  const dataToSend = {
    id_vinculo: data.id_vinculo,
    id_paciente: data.id_paciente,
    nu_consulta: data.nu_consulta,
    respostas: [
      {
        pergunta: 1,
        resposta: data.anamnese,
      },
      {
        pergunta: 2,
        resposta: data.estadoInicioDoenca,
      },
      {
        pergunta: 3,
        resposta: data.municipioInicioDoenca,
      },
      {
        pergunta: 4,
        resposta: data.tempoMoradiaMunicipio,
      },
      {
        pergunta: 5,
        resposta: data.localPrimeiroSintoma,
      },
      {
        pergunta: 6,
        resposta: data.dataPrimeiroSintoma,
      },
      {
        pergunta: 7,
        resposta: data.idadeInicioSintomas,
      },
      {
        pergunta: 8,
        resposta: data.altura,
      },
      {
        pergunta: 9,
        resposta: data.peso,
      },
      {
        pergunta: 10,
        resposta: data.imc,
      },
      {
        pergunta: 11,
        resposta: data.sinaisSintomas,
      },
      {
        pergunta: 12,
        resposta: data.sinaisSintomasOutros,
      },
      {
        pergunta: 13,
        resposta: data.antecedentesPessoais,
      },
      {
        pergunta: 14,
        resposta: data.antecedentesPessoaisOutros,
      },
      {
        pergunta: 15,
        resposta: data.comorbidadesSelecionadas,
      },
      {
        pergunta: 16,
        resposta: data.comorbidadeOutras,
      },
      {
        pergunta: 17,
        resposta: data.possuiCirurgias,
      },
      {
        pergunta: 18,
        resposta: data.listagemCirurgias,
      },
      {
        pergunta: 20,
        resposta: data.historicoFamiliarELA,
      },
      {
        pergunta: 201,
        resposta: data.historicoFamiliarELAQuem,
      },
      {
        pergunta: 21,
        resposta: data.historicoFamiliarELAOutros,
      },
      {
        pergunta: 22,
        resposta: data.historicoFamiliarDemencia,
      },
      {
        pergunta: 202,
        resposta: data.historicoFamiliarDemenciaQuem,
      },
      {
        pergunta: 23,
        resposta: data.historicoFamiliarDemenciaOutros,
      },
      {
        pergunta: 24,
        resposta: data.historicoFamiliarDoencaPsiquiatrica,
      },
      {
        pergunta: 203,
        resposta: data.historicoFamiliarDoencaPsiquiatricaQuem,
      },
      {
        pergunta: 25,
        resposta: data.historicoDoencaPsiquiatricaOutros,
      },
      {
        pergunta: 26,
        resposta: data.usaRiluzol,
      },
      {
        pergunta: 27,
        resposta: data.dataRiluzol,
      },
      {
        pergunta: 28,
        resposta: data.medicamentosUsados,
      },
      /*{
        pergunta: 29,
        resposta: ''
      },*/
      {
        pergunta: 30,
        resposta: data.alergiaAlimentos,
      },
      {
        pergunta: 31,
        resposta: data.alergiaMedicamentos,
      },
      {
        pergunta: 32,
        resposta: data.alergiaOutros,
      },
      {
        pergunta: 33,
        resposta: data.observacoes,
      },
    ],
  };

  try {
    const response = await api.post("/primeira-consulta/", {
      data: dataToSend,
    });

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
      return null;
    }

    return response.data.idConsulta;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return null;
  }
}
export async function requestPrimeiraConsultaDadosClinicosEdit(data) {
  const dataToSend = {
    id_vinculo: data.id_vinculo,
    id_paciente: data.id_paciente,
    nu_consulta: data.nu_consulta,
    id_consulta_evolucao: data.id_consulta_evolucao,
    respostas: [
      {
        pergunta: 11,
        resposta: data.sinaisSintomas,
      },
      {
        pergunta: 12,
        resposta: data.sinaisSintomasOutros,
      },
      {
        pergunta: 13,
        resposta: data.antecedentesPessoais,
      },
      {
        pergunta: 14,
        resposta: data.antecedentesPessoaisOutros,
      },
      {
        pergunta: 15,
        resposta: data.comorbidadesSelecionadas,
      },
      {
        pergunta: 16,
        resposta: data.comorbidadeOutras,
      },
      {
        pergunta: 17,
        resposta: data.possuiCirurgias,
      },
      {
        pergunta: 18,
        resposta: data.listagemCirurgias,
      },
      {
        pergunta: 20,
        resposta: data.historicoFamiliarELA,
      },
      {
        pergunta: 201,
        resposta: data.historicoFamiliarELAQuem,
      },
      {
        pergunta: 21,
        resposta: data.historicoFamiliarELAOutros,
      },
      {
        pergunta: 22,
        resposta: data.historicoFamiliarDemencia,
      },
      {
        pergunta: 202,
        resposta: data.historicoFamiliarDemenciaQuem,
      },
      {
        pergunta: 23,
        resposta: data.historicoFamiliarDemenciaOutros,
      },
      {
        pergunta: 24,
        resposta: data.historicoFamiliarDoencaPsiquiatrica,
      },
      {
        pergunta: 203,
        resposta: data.historicoFamiliarDoencaPsiquiatricaQuem,
      },
      {
        pergunta: 25,
        resposta: data.historicoDoencaPsiquiatricaOutros,
      },
      {
        pergunta: 26,
        resposta: data.usaRiluzol,
      },
      {
        pergunta: 27,
        resposta: data.dataRiluzol,
      },
      {
        pergunta: 28,
        resposta: data.medicamentosUsados,
      },
      /*{
        pergunta: 29,
        resposta: ''
      },*/
      {
        pergunta: 30,
        resposta: data.alergiaAlimentos,
      },
      {
        pergunta: 31,
        resposta: data.alergiaMedicamentos,
      },
      {
        pergunta: 32,
        resposta: data.alergiaOutros,
      },
      {
        pergunta: 33,
        resposta: data.observacoes,
      },
    ],
  };

  try {
    const response = await api.patch("/primeira-consulta/", {
      data: dataToSend,
    });

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
      return null;
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return null;
  }
}

export async function requestAnamneseNeurologica(data) {
  const dataToSend = {
    id_paciente: parseInt(data.idPaciente),
    id_vinculo: parseInt(data.idVinculo),
    nu_consulta: data.nu_consulta,
    ...(data.isMultidisciplinar && {
      id_consulta_evolucao: data.id_consulta_evolucao,
      id_consulta: data.id_consulta,
    }),
    respostas: [
      {
        pergunta: 1,
        resposta: data.anamnese,
      },
      {
        pergunta: 11,
        resposta: data.sinaisSintomas,
      },
      {
        pergunta: 12,
        resposta: data.sinaisSintomasOutros,
      },
      {
        pergunta: 34,
        resposta: data.ventilacaoNaoInvasivaBIPAP,
      },
      {
        pergunta: 35,
        resposta: data.bipapDataInicio,
      },
      {
        pergunta: 36,
        resposta: data.bipapDuracao,
      },
      {
        pergunta: 37,
        resposta: data.traquestomia,
      },
      {
        pergunta: 38,
        resposta: data.traqueostomiaDataInicio,
      },
      {
        pergunta: 39,
        resposta: data.traqueostomiaProcedimento,
      },
      {
        pergunta: 40,
        resposta: data.gastrostomia,
      },
      {
        pergunta: 41,
        resposta: data.gastrostomiaDataInicio,
      },
      {
        pergunta: 42,
        resposta: data.sondaNasogastrica,
      },
      {
        pergunta: 43,
        resposta: data.sondaNasogastricaDataInicio,
      },
      {
        pergunta: 44,
        resposta: data.coughAssist,
      },
      {
        pergunta: 45,
        resposta: data.tecnologiaComunicacao,
      },
      {
        pergunta: 50,
        resposta: data.assistenciaDomiciliar,
      },
      {
        pergunta: 46,
        resposta: data.usoCadeiraDeRodas,
      },
      {
        pergunta: 47,
        resposta: data.tipoProcedimento,
      },
      {
        pergunta: 48,
        resposta: data.multidisciplinar,
      },
      {
        pergunta: 49,
        resposta: data.multidisciplinarTipo,
      },
      {
        pergunta: 51,
        resposta: data.frequenciaCardiaca,
      },
      {
        pergunta: 52,
        resposta: data.pressaoArterial,
      },
      {
        pergunta: 53,
        resposta: data.pesoAtual,
      },
      {
        pergunta: 54,
        resposta: data.perdaDePeso,
      },
      {
        pergunta: 55,
        resposta: data.apatia,
      },
      {
        pergunta: 56,
        resposta: data.statusCognitivo,
      },
      {
        pergunta: 57,
        resposta: data.rastreioComportamental,
      },
      {
        pergunta: 58,
        resposta: data.fluenciaVerbal,
      },
    ],
  };

  try {
    let response = {};
    if (data.isMultidisciplinar) {
      response = await api.post("/consulta-agendada/", {
        data: dataToSend,
      });
    } else {
      response = await api.post("/consulta/", {
        data: dataToSend,
      });
    }

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}

export async function requestAnamneseDadosGerais(data) {
  const pesoAtual =
    data.pesoAtual === ""
      ? ""
      : parseFloat(`${data.pesoAtual.slice(0, 3)},${data.pesoAtual.slice(3)}`);
  const dataToSend = {
    id_paciente: parseInt(data.idPaciente),
    id_vinculo_ps: parseInt(data.idVinculo),
    id_consulta: data.id_consulta,
    respostas: [
      {
        pergunta: 51,
        resposta: data.frequenciaCardiaca,
      },
      {
        pergunta: 52,
        resposta: data.pressaoArterial,
      },
      {
        pergunta: 53,
        resposta: pesoAtual ?? "",
      },
      {
        pergunta: 54,
        resposta: data.perdaDePeso,
      },
      {
        pergunta: 55,
        resposta: data.apatia,
      },
      {
        pergunta: 56,
        resposta: data.statusCognitivo,
      },
      {
        pergunta: 57,
        resposta: data.rastreioComportamental,
      },
      {
        pergunta: 58,
        resposta: data.fluenciaVerbal,
      },
      {
        pergunta: 233,
        resposta: data.capacidadeVitalForcada,
      },
      {
        pergunta: 234,
        resposta: data.pressaoInspiratoria,
      },
      {
        pergunta: 235,
        resposta: data.pressaoExpiratoria,
      },
      {
        pergunta: 236,
        resposta: data.pressaoNasalInspiratoria,
      },
    ],
  };

  try {
    let response = {};
    response = await api.post("/anaminese/", {
      data: dataToSend,
    });

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}

export async function requestExameNeurologicoMotor(data) {
  const dataToSend = {
    id_paciente: parseInt(data.idPaciente),
    id_vinculo: parseInt(data.idVinculo),
    nu_consulta: data.nu_consulta,
    ...(data.isMultidisciplinar && {
      id_consulta_evolucao: data.id_consulta_evolucao,
      id_consulta: data.id_consulta,
    }),
    respostas: [
      {
        pergunta: 73,
        resposta: data.abducaoCoxasDireita,
      },
      {
        pergunta: 74,
        resposta: data.abducaoCoxasEsquerda,
      },
      {
        pergunta: 76,
        resposta: data.flexaoQuadrisDireita,
      },
      {
        pergunta: 77,
        resposta: data.flexaoQuadrisEsquerda,
      },
      {
        pergunta: 79,
        resposta: data.extensaoJoelhosDireita,
      },
      {
        pergunta: 80,
        resposta: data.extensaoJoelhosEsquerda,
      },
      {
        pergunta: 82,
        resposta: data.flexaoJoelhosDireita,
      },
      {
        pergunta: 83,
        resposta: data.flexaoJoelhosEsquerda,
      },
      {
        pergunta: 85,
        resposta: data.dorsiflexaoJoelhosDireita,
      },
      {
        pergunta: 86,
        resposta: data.dorsiflexaoJoelhosEsquerda,
      },
      {
        pergunta: 88,
        resposta: data.inversaoPesDireita,
      },
      {
        pergunta: 89,
        resposta: data.inversaoPesEsquerda,
      },
      {
        pergunta: 91,
        resposta: data.flexaoPlanarPesDireita,
      },
      {
        pergunta: 92,
        resposta: data.flexaoPlanarPesEsquerda,
      },
      {
        pergunta: 94,
        resposta: data.abducaoOmbrosDireita,
      },
      {
        pergunta: 95,
        resposta: data.abducaoOmbrosEsquerda,
      },
      {
        pergunta: 97,
        resposta: data.flexaoCotovelosDireita,
      },
      {
        pergunta: 98,
        resposta: data.flexaoCotovelosEsquerda,
      },
      {
        pergunta: 100,
        resposta: data.extensaoCotovelosDireita,
      },
      {
        pergunta: 101,
        resposta: data.extensaoCotovelosEsquerda,
      },
      {
        pergunta: 103,
        resposta: data.flexaoPunhosDireita,
      },
      {
        pergunta: 104,
        resposta: data.flexaoPunhosEsquerda,
      },
      {
        pergunta: 106,
        resposta: data.extensaoDedosDireita,
      },
      {
        pergunta: 107,
        resposta: data.extensaoDedosEsquerda,
      },
      {
        pergunta: 109,
        resposta: data.abducaoDedosDireita,
      },
      {
        pergunta: 110,
        resposta: data.abducaoDedosEsquerda,
      },
      {
        pergunta: 112,
        resposta: data.abducaoPolegarDireita,
      },
      {
        pergunta: 113,
        resposta: data.abducaoPolegarEsquerda,
      },
      {
        pergunta: 115,
        resposta: data.primeiroInterosseoDorsalDireita,
      },
      {
        pergunta: 116,
        resposta: data.primeiroInterosseoDorsalEsquerda,
      },
      {
        pergunta: 117,
        resposta: data.MIDProximal,
      },
      {
        pergunta: 118,
        resposta: data.MIDDistal,
      },
      {
        pergunta: 119,
        resposta: data.MIEProximal,
      },
      {
        pergunta: 120,
        resposta: data.MIEDistal,
      },
      {
        pergunta: 121,
        resposta: data.MSDProximal,
      },
      {
        pergunta: 122,
        resposta: data.MSDDistal,
      },
      {
        pergunta: 123,
        resposta: data.MSEProximal,
      },
      {
        pergunta: 124,
        resposta: data.MSEDistal,
      },
      {
        pergunta: 125,
        resposta: data.fasciculacoesMotor,
      },
      {
        pergunta: 126,
        resposta: data.fasciculacoesMotorOnde,
      },
      {
        pergunta: 127,
        resposta: data.MSD,
      },
      {
        pergunta: 128,
        resposta: data.MSE,
      },
      {
        pergunta: 129,
        resposta: data.MID,
      },
      {
        pergunta: 130,
        resposta: data.MIE,
      },
      {
        pergunta: 132,
        resposta: data.reflexoBicipitalDireita,
      },
      {
        pergunta: 133,
        resposta: data.reflexoBicipitalEsquerda,
      },
      {
        pergunta: 135,
        resposta: data.reflexoTricipitalDireita,
      },
      {
        pergunta: 136,
        resposta: data.reflexoTricipitalEsquerda,
      },
      {
        pergunta: 138,
        resposta: data.reflexoPatelarDireita,
      },
      {
        pergunta: 139,
        resposta: data.reflexoPatelarEsquerda,
      },
      {
        pergunta: 141,
        resposta: data.reflexoAquileuDireita,
      },
      {
        pergunta: 142,
        resposta: data.reflexoAquileuEsquerda,
      },
      {
        pergunta: 147,
        resposta: data.reflexoCutaneoDireita,
      },
      {
        pergunta: 148,
        resposta: data.reflexoCutaneoEsquerda,
      },
      {
        pergunta: 150,
        resposta: data.sinalDeHoffmannDireita,
      },
      {
        pergunta: 151,
        resposta: data.sinalDeHoffmannEsquerda,
      },
      {
        pergunta: 152,
        resposta: data.tremor,
      },
      {
        pergunta: 153,
        resposta: data.ataxia,
      },
      {
        pergunta: 154,
        resposta: data.bradicinesia,
      },
    ],
  };

  try {
    let response = {};
    if (data.isMultidisciplinar) {
      response = await api.post("/consulta-agendada/", {
        data: dataToSend,
      });
    } else {
      response = await api.post("/consulta/", {
        data: dataToSend,
      });
    }

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}

export async function requestExameNeurologicoNervosCranianos(data) {
  const dataToSend = {
    id_paciente: parseInt(data.idPaciente),
    id_vinculo: parseInt(data.idVinculo),
    nu_consulta: data.nu_consulta,
    ...(data.isMultidisciplinar && {
      id_consulta_evolucao: data.id_consulta_evolucao,
      id_consulta: data.id_consulta,
    }),
    respostas: [
      {
        pergunta: 59,
        resposta: data.reflexoFotomotor,
      },
      {
        pergunta: 60,
        resposta: data.papilederma,
      },
      {
        pergunta: 61,
        resposta: data.motricidadeOcular,
      },
      {
        pergunta: 62,
        resposta: data.ptosePalpebral,
      },
      {
        pergunta: 63,
        resposta: data.reflexoNauseoso,
      },
      {
        pergunta: 64,
        resposta: data.musculaturaFacial,
      },
      {
        pergunta: 65,
        resposta: data.masseter,
      },
      {
        pergunta: 66,
        resposta: data.linguaMovimentacao,
      },
      {
        pergunta: 67,
        resposta: data.linguaAtrofia,
      },
      {
        pergunta: 68,
        resposta: data.linguaFasciculacao,
      },
      {
        pergunta: 69,
        resposta: data.veloPalatino,
      },
      {
        pergunta: 70,
        resposta: data.disartria,
      },
      {
        pergunta: 71,
        resposta: data.anartria,
      },
    ],
  };

  try {
    let response = {};
    if (data.isMultidisciplinar) {
      response = await api.post("/consulta-agendada/", {
        data: dataToSend,
      });
    } else {
      response = await api.post("/consulta/", {
        data: dataToSend,
      });
    }

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}

export async function requestExameNeurologicoSensibilidade(data) {
  const dataToSend = {
    id_paciente: parseInt(data.idPaciente),
    id_vinculo: parseInt(data.idVinculo),
    nu_consulta: data.nu_consulta,
    ...(data.isMultidisciplinar && {
      id_consulta_evolucao: data.id_consulta_evolucao,
      id_consulta: data.id_consulta,
    }),
    respostas: [
      {
        pergunta: 155,
        resposta: data.parestesias,
      },
      {
        pergunta: 156,
        resposta: data.disestesias,
      },
      {
        pergunta: 157,
        resposta: data.alodinia,
      },
      {
        pergunta: 159,
        resposta: data.MIDProximalVibratoria,
      },
      {
        pergunta: 160,
        resposta: data.MIDProximalCinetPost,
      },
      {
        pergunta: 161,
        resposta: data.MIDProximalTactil,
      },
      {
        pergunta: 162,
        resposta: data.MIDProximalDor,
      },
      {
        pergunta: 164,
        resposta: data.MIDDistalVibratoria,
      },
      {
        pergunta: 165,
        resposta: data.MIDDistalCinetPost,
      },
      {
        pergunta: 166,
        resposta: data.MIDDistalTactil,
      },
      {
        pergunta: 167,
        resposta: data.MIDDistalDor,
      },
      {
        pergunta: 169,
        resposta: data.MIEProximalVibratoria,
      },
      {
        pergunta: 170,
        resposta: data.MIEProximalCinetPost,
      },
      {
        pergunta: 171,
        resposta: data.MIEProximalTactil,
      },
      {
        pergunta: 172,
        resposta: data.MIEProximalDor,
      },
      {
        pergunta: 174,
        resposta: data.MIEDistalVibratoria,
      },
      {
        pergunta: 175,
        resposta: data.MIEDistalCinetPost,
      },
      {
        pergunta: 176,
        resposta: data.MIEDistalTactil,
      },
      {
        pergunta: 177,
        resposta: data.MIEDistalDor,
      },
      {
        pergunta: 179,
        resposta: data.MSDProximalVibratoria,
      },
      {
        pergunta: 180,
        resposta: data.MSDProximalCinetPost,
      },
      {
        pergunta: 181,
        resposta: data.MSDProximalTactil,
      },
      {
        pergunta: 182,
        resposta: data.MSDProximalDor,
      },
      {
        pergunta: 184,
        resposta: data.MSDDistalVibratoria,
      },
      {
        pergunta: 185,
        resposta: data.MSDDistalCinetPost,
      },
      {
        pergunta: 186,
        resposta: data.MSDDistalTactil,
      },
      {
        pergunta: 187,
        resposta: data.MSDDistalDor,
      },
      {
        pergunta: 189,
        resposta: data.MSEProximalVibratoria,
      },
      {
        pergunta: 190,
        resposta: data.MSEProximalCinetPost,
      },
      {
        pergunta: 191,
        resposta: data.MSEProximalTactil,
      },
      {
        pergunta: 192,
        resposta: data.MSEProximalDor,
      },
      {
        pergunta: 194,
        resposta: data.MSEDistalVibratoria,
      },
      {
        pergunta: 195,
        resposta: data.MSEDistalCinetPost,
      },
      {
        pergunta: 196,
        resposta: data.MSEDistalTactil,
      },
      {
        pergunta: 197,
        resposta: data.MSEDistalDor,
      },
      {
        pergunta: 198,
        resposta: data.disfuncaoAutonomica,
      },
      {
        pergunta: 199,
        resposta: data.tipoDisfuncao,
      },
      {
        pergunta: 200,
        resposta: data.disfuncaoAutonomicaOutra,
      },
    ],
  };

  try {
    let response = {};
    if (data.isMultidisciplinar) {
      response = await api.post("/consulta-agendada/", {
        data: dataToSend,
      });
    } else {
      response = await api.post("/consulta/", {
        data: dataToSend,
      });
    }

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}

export async function requestDiagnosticoELA(data) {
  const dataToSend = {
    id_paciente: parseInt(data.idPaciente),
    id_vinculo: parseInt(data.idVinculo),
    nu_consulta: data.nu_consulta,
    ...(data.isMultidisciplinar && {
      id_consulta_evolucao: data.id_consulta_evolucao,
      id_consulta: data.id_consulta,
    }),
    respostas: [
      {
        pergunta: 204,
        resposta: data.diagnosticoEhELA,
      },
      {
        pergunta: 205,
        resposta: data.dataDiagnosticoELA,
      },
      {
        pergunta: 206,
        resposta: data.classificacaoKingsCollege,
      },
      {
        pergunta: 207,
        resposta: data.escalaFuncional,
      },
      {
        pergunta: 208,
        resposta: data.velocidadeDeProgressao,
      },
      {
        pergunta: 209,
        resposta: data.causaELA,
      },
      {
        pergunta: 210,
        resposta: data.localDeInicio,
      },
      {
        pergunta: 211,
        resposta: data.fenotipoDeInicio,
      },
      {
        pergunta: 212,
        resposta: data.observacaoELA,
      },
      {
        pergunta: 213,
        resposta: data.sugestaoDiagnostico,
      },
    ],
  };

  try {
    let response = {};
    if (data.isMultidisciplinar) {
      response = await api.post("/consulta-agendada/", {
        data: dataToSend,
      });
    } else {
      response = await api.post("/consulta/", {
        data: dataToSend,
      });
    }

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}

export async function requestExamesEProcedimentos(data) {
  const dataToSendExames = {
    id_vinculo: data.idVinculo,
    id_paciente: data.idPaciente,
    nu_consulta: data.nu_consulta,
    id_consulta: data.id_consulta,
    id_consulta_evolucao: data.id_consulta_evolucao,
    examesPredefinidos: data.examesPredefinidosExamesEProcedimentos,
    outrosExamesLaboratoriais: data.outrosExamesLaboratoriais,
    examesLaboratoriaisObservacao: data.examesLaboratoriaisObservacao,
  };

  const dataToSendOutrosExames = {
    id_vinculo: data.idVinculo,
    id_paciente: data.idPaciente,
    id_consulta: data.id_consulta,
    id_consulta_evolucao: data.id_consulta_evolucao,
    exames: data.solicitacaoOutrosExames,
  };

  let responseExames = {};
  let responseOutrosExames = {};
  try {
    if (
      data.examesPredefinidosExamesEProcedimentos.length > 0 ||
      data.outrosExamesLaboratoriais.length > 0
    ) {
      responseExames = await api.post("/exames", {
        data: dataToSendExames,
      });
    }

    if (data.solicitacaoOutrosExames.length > 0) {
      responseOutrosExames = await api.post("/outros-exames/", {
        data: dataToSendOutrosExames,
      });
    }

    if (responseExames?.data?.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os exames. Por favor, tente novamente mais tarde."
      );
      return null;
    }

    if (responseOutrosExames?.data?.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os exames. Por favor, tente novamente mais tarde."
      );
      return null;
    }

    return responseExames.data || responseOutrosExames.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return null;
  }
}

export async function requestPrescricaoMedicamento(data) {
  const dataToSend = {
    id_paciente: parseInt(data.idPaciente),
    id_vinculo: parseInt(data.idVinculo),
    nu_consulta: data.nu_consulta,
    medicamentos: data.medicamentosAdicionados,
  };

  try {
    const response = await api.post("/prescricao-medicamentos/", {
      data: dataToSend,
    });

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}

export async function requestAnamneseReavaliacao(data) {
  const dataToSend = {
    id_paciente: parseInt(data.idPaciente),
    id_vinculo: parseInt(data.idVinculo),
    ...(data.isMultidisciplinar && {
      id_consulta_evolucao: data.id_consulta_evolucao,
      id_consulta: data.id_consulta,
    }),
    respostas: [
      {
        pergunta: 1,
        resposta: data.anamnese,
      },
      {
        pergunta: 232,
        resposta: data.sintomasEQueixas,
      },
    ],
  };

  try {
    let response = {};
    if (data.isMultidisciplinar) {
      response = await api.post("/consulta-agendada/", {
        data: dataToSend,
      });
    } else {
      response = await api.post("/consulta/", {
        data: dataToSend,
      });
    }

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}

export async function requestCondutaConclusaoEncaminhamentos(data) {
  const dataToSend = {
    id_paciente: parseInt(data.idPaciente),
    id_vinculo: parseInt(data.idVinculo),
    nu_consulta: data.nu_consulta,
    ...(data.isMultidisciplinar && {
      id_consulta_evolucao: data.id_consulta_evolucao,
      id_consulta: data.id_consulta,
    }),
    respostas: [
      {
        pergunta: 231,
        resposta: data.condutaConclusaoEncaminhamentos,
      },
    ],
  };

  try {
    let response = {};
    if (data.isMultidisciplinar) {
      response = await api.post("/consulta-agendada/", {
        data: dataToSend,
      });
    } else {
      response = await api.post("/consulta/", {
        data: dataToSend,
      });
    }

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}

export async function requestAgendarConsulta(data) {
  const dataToSend = {
    id_vinculo: data.idVinculo,
    id_paciente: data.idPaciente,
    nu_consulta: data.nu_consulta,
    id_estabelecimento_saude: data.idEstabelecimento,
    dt_consulta: data.dataAgendamento,
    nu_hora_consulta: data.horaAgendamento,
    id_categoria: data.tipoConsulta,
    participants: data.equipeDeSaudeTotal,
  };

  try {
    const response = await api.post("/agendar-consulta/", {
      data: dataToSend,
    });

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}
export async function requestUpdateAgendarConsulta(data) {
  const dataToSend = {
    id_consulta: data.idConsulta,
    id_vinculo: data.idVinculo,
    id_paciente: data.idPaciente,
    dt_consulta: data.dataAgendamento,
    nu_hora_consulta: data.horaAgendamento,
    id_categoria: data.tipoConsulta,
    participants: data.equipeDeSaudeTotal,
  };

  try {
    const response = await api.put("/agenda/", {
      data: dataToSend,
    });

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}
export async function requestCancelAppointment(data) {
  const dataToSend = {
    id_consulta: data.idConsulta,
    id_vinculo_ps: data.idVinculo,
  };
  try {
    const response = await api.put("/cancelar-agenda/", {
      data: dataToSend,
    });
    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}

export async function atualizarDadosPaciente(data) {
  const dataToSend = {
    paciente: {
      no_nome_usuario: data.nome,
      no_nome_social_usuario: data.nomeSocial,
      no_nome_mae: data.nomeMae,
      no_email: data.email,
      dt_nascimento: data.dataNascimento,
      co_naturalidade: data.naturalidade,
      co_municipio_nascimento: data.municipioNascimento,
      co_sexo_biologico: data.sexoBiologico,
      co_raca_cor: data.racaCor,
      co_identidade_genero: data.identidadeGenero,
      co_estado_civil: data.estadoCivil,
      co_religiao: data.religiao,
      co_religiao_outros: "",
      co_lateralidade: data.lateralidade,
      co_escolaridade: data.escolaridade,
      co_cbo: data.profissao,
      co_tipo_trabalho: data.tipoTrabalho,
      no_atividades_profissionais: data.ultimasAtividadesProfissionais,
      co_condicao_atual: data.condicaoAtual,
      no_tempo_condicao_atual: data.tempoCondicaoAtual,
    },
    endereco: {
      no_logradouro: data.enderecoLogradouro,
      no_numero: data.enderecoNumero,
      no_complemento: data.enderecoComplemento,
      no_bairro: data.enderecoBairro,
      no_cep: data.enderecoCep,
      co_cidade: data.enderecoIBGE,
      co_estado: data.enderecoCodigoUf,
    },
    telefone: {
      no_numero: data.numeroTelefone,
      no_responsavel: data.responsavelTelefone,
    },
  };

  try {
    const response = await api.put(`/paciente/${data.id}`, {
      data: dataToSend,
    });

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );

      return false;
    }

    return true;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return false;
  }
}

export async function autocadastroPaciente(data) {
  const dataToSend = {
    user: {
      no_cpf: data.cpf.replace(/\D/g, ""),
      no_cns: data.cns.replace(/\s/g, ""),
      no_nome_usuario: data.nome,
      no_nome_mae: data.nomeDaMae,
      no_email: data.email,
      co_sexo_biologico: data.sexo,
      co_identidade_genero: data.identidadeDeGenero,
      co_raca_cor: data.raca,
      dt_nascimento: data.dataNascimento,
      co_naturalidade: data.naturalidade,
      co_estado_civil: data.estadoCivil,
      co_cbo: data.profissao,
    },
    patient: {
      co_lateralidade: data.lateralidade,
      co_religiao: data.religiao,
      co_escolaridade: data.escolaridade,
      co_tipo_trabalho: data.tipoTrabalho,
      no_atividades_profissionais: data.ultimasAtividadesProfissionais,
      co_condicao_atual: data.condicaoAtual,
      no_tempo_condicao_atual: data.tempoCondicaoAtual,
      co_municipio_nascimento: data.municipioNascimento,
      no_senha: bcrypt.hashSync(data.senha),
    },
    address: {
      no_logradouro: data.enderecoLogradouro,
      no_numero: data.enderecoNumero,
      no_complemento: data.enderecoComplemento,
      no_bairro: data.enderecoBairro,
      no_cep: data.enderecoCep,
      co_cidade: data.enderecoIBGE,
      co_estado: data.enderecoCodigoUf,
    },
    phones: data.dadosDeContato,
  };

  try {
    const response = await api.post(`/autocadastro-paciente`, {
      data: dataToSend,
    });

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
      );

      return false;
    }

    return true;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return false;
  }
}

export async function requestEscalaALS(data) {
  const dataToSend = {
    id_paciente: parseInt(data.idPaciente),
    id_vinculo_ps_respondente: parseInt(data.idVinculo),
    id_consulta: parseInt(data.idConsulta) || null,
    total: data.total,
    respostas: [
      {
        pergunta: 214,
        resposta: data.respostas.a,
      },
      {
        pergunta: 215,
        resposta: data.respostas.b,
      },
      {
        pergunta: 216,
        resposta: data.respostas.c,
      },
      {
        pergunta: 217,
        resposta: data.respostas.d,
      },
      {
        pergunta: 218,
        resposta: data.respostas.e1 || null,
      },
      {
        pergunta: 219,
        resposta: data.respostas.e2 || null,
      },
      {
        pergunta: 220,
        resposta: data.respostas.f,
      },
      {
        pergunta: 221,
        resposta: data.respostas.g,
      },
      {
        pergunta: 222,
        resposta: data.respostas.h,
      },
      {
        pergunta: 223,
        resposta: data.respostas.i,
      },
      {
        pergunta: 224,
        resposta: data.respostas.j,
      },
      {
        pergunta: 225,
        resposta: data.respostas.k,
      },
      {
        pergunta: 226,
        resposta: data.respostas.l,
      },
      {
        pergunta: 227,
        resposta: data.subescalaBulbar,
      },
      {
        pergunta: 228,
        resposta: data.subescalaMotorFino,
      },
      {
        pergunta: 229,
        resposta: data.subescalaTronco,
      },
      {
        pergunta: 230,
        resposta: data.subescalaRespiratoria,
      },
    ],
  };

  try {
    const response = await api.post("/escala", {
      data: dataToSend,
    });

    if (response.data.hasOwnProperty("error")) {
      alert(
        "No momento, não é possível cadastrar as respostas. Por favor, tente novamente mais tarde."
      );
    }

    return response.data;
  } catch (error) {
    alert(
      "No momento, não é possível cadastrar os dados da consulta. Por favor, tente novamente mais tarde."
    );
    return error;
  }
}
